import quot from '@/api/wholesale/quotation'
import moment from 'moment'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  products: [],
  customers: [],
  dateRange: [moment().add(-7, 'days').format('DD-MM-YYYY'), moment().format('DD-MM-YYYY')]
}

export const getters = {
  getProduct: state => ({ chosenProduct, search = '', substituteCode = '' } = {}) => {
  if (chosenProduct !== undefined) {
    return state.products
      .filter(p =>
        !_.includes(chosenProduct.map(el => el.product_id), p.product_id)
      )
      .filter(p => {
        if (!search && !substituteCode) return true

        if (substituteCode && !search) {
          return (p.substitute_code || '').toLowerCase().includes(substituteCode.toLowerCase())
        }

        if (search && !substituteCode) {
          return (
            search.split(' ').every(s =>
              (p.product_name_en || '').toLowerCase().includes(s.toLowerCase())
            ) ||
            search.split(' ').every(s =>
              (p.barcode || '').toLowerCase().includes(s.toLowerCase())
            )
          )
        }

        const matchSearch = (
          search.split(' ').every(s =>
            (p.product_name_en || '').toLowerCase().includes(s.toLowerCase())
          ) ||
          search.split(' ').every(s =>
            (p.barcode || '').toLowerCase().includes(s.toLowerCase())
          )
        )
        const matchSubCode = (p.substitute_code || '').toLowerCase().includes(substituteCode.toLowerCase())
        return matchSearch && matchSubCode
      })
      .slice(0, 400)
  }
  return state.products.slice(0, 400)
},
  getUom: state => productId => {
    return state.products.filter(p => p.product_id == productId)
      .map(el => el.uom_category.unit_of_measures)
      .flat()
  },
  isDefaultUom: state => productId => {
    if (productId) {
      return state.products.filter(p => p.product_id == productId)
        .map(el => el.uom_category.unit_of_measures).flat()
        .filter(d => d.is_default == true)
        .map(el => el.uom_id)
        .reduce((init, value) => init = value)
    }
    return null
  },
  getSalePrice: state => ({ product_id, uom_id }) => {
    return state.products.filter(p => p.product_id == product_id)
      .reduce((i, v) => i = v.sale_code, [])
      .filter(s => s.uom_id == uom_id)
      .reduce((i, v) => i = v.product_price.sale_price, 0)
  },
  getSpecification: state => ({ product_id, uom_id }) => {
    if (product_id && uom_id) {
      let r = state.products.filter(p => p.product_id == product_id)
        .reduce((i, v) => i = v.sale_code, [])
        .filter(s => s.uom_id == uom_id)
      let specific = r[0] ? r[0].specification : []
      if (specific) {
        return specific ? specific.specification : []
      }
    } else {
      return null
    }
  },
  getCreditDay: state => customerId => {
    return state.customers.filter(c => c.customer_id == customerId).reduce((i, v) => i = v.credit_day, 0)
  },
  findProduct: state => productId => {
    if (!productId) {
      return {
        barcode: null,
        product_name_en: null,
        substitute_code: null
      }
    }
    return state.products.find(p => p.product_id == productId) || {
    barcode: null,
    product_name_en: null,
    substitute_code: null
   }
  },
}

export const mutations = {
  ...baseMutations,
  SET_DATE_RANGE(state, date) {
    state.dateRange = date
  },
  SET_PRODUCT(state, data) {
    state.products = data
  },
  SET_CUSTOMER(state, data) {
    state.customers = data
  },
  CLEAR_SETUP(state) {
    state.products = []
    state.customers = []
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        branch_id: context.state.branch_id,
        filter: {
          search: context.state.search,
          date_between: _.join(context.state.dateRange, ',')
        }
      },
      attrubutes
    )
    return quot.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return quot.store(data)
  },
  update(context, { id, data }) {
    return quot.update(id, data)
  },
  confirmSale(context, data) {
    return quot.confirmSale(data)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await quot.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  destroy(context, { id, data }) {
    return quot.destroy(id, data)
  },
  reprint(context, data) {
    return quot.reprint(data)
  },
  async fetchResource(context) {
    let var_product = await quot.product()
    context.commit('SET_PRODUCT', var_product.data)
    let var_customer = await quot.customer()
    context.commit('SET_CUSTOMER', var_customer)
  },

  async searchCustomer(context, search = '') {
    let var_customer = await quot.customer({ params: { search_customer: search } })
    context.commit('SET_CUSTOMER', var_customer)
  }
}
